export default __webpack_public_path__ + "img/send-test.3a8fcdfa.svg";